<rpshared-save-bar
	[title]="title$ | async"
	[isSaving]="isSaving$ | async"
	[isFormInvalid]="invalidSubmission$ | async"
	(save)="save($event)"
></rpshared-save-bar>

<div [formGroup]="form" gdGap="10px" class="with-fixed-sub-toolbar">
	<rpshared-mat-loading-card
		[isLoading]="isLoading$ | async"
		icon="train"
		title="General Information"
	>
		<rpfsa-team-general-info
			gdColumns="repeat(auto-fill, minmax(250px, 1fr))"
			gdGap="10px"
			formControlName="generalInfo"
		></rpfsa-team-general-info>
	</rpshared-mat-loading-card>

	<rpshared-mat-loading-card
		*ngIf="!(isNewRecord$ | async)"
		[isLoading]="isLoading$ | async"
		icon="people"
		title="Team Members"
	>
		<rpshared-field-worker-link-list formControlName="members">
		</rpshared-field-worker-link-list>
	</rpshared-mat-loading-card>
</div>
